import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { Home } from "./pages/Home";
import { Formations } from "./pages/Formations";
import { Experiences } from "./pages/Experiences";
import { Applications } from "./pages/Applications";
import { Services } from "./pages/Services";
import { Contact } from "./pages/Contact";
import { Admin } from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentError from "./pages/PaymentError";
import TogalmaPrivacy from "./pages/TogalmaPrivacy";

// Layout for public pages
const PublicLayout = ({ children }) => (
    <>
        <Navbar />
        {children}
        <Footer />
    </>
);

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <AuthProvider>
                    <div className="App">
                        <BrowserRouter>
                            <Routes>
                                {/* Public Routes */}
                                <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                                <Route path="/formations" element={<PublicLayout><Formations /></PublicLayout>} />
                                <Route path="/experiences" element={<PublicLayout><Experiences /></PublicLayout>} />
                                <Route path="/applications" element={<PublicLayout><Applications /></PublicLayout>} />
                                <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
                                <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                                <Route path="/togalma/confidentialite" element={<PublicLayout><TogalmaPrivacy /></PublicLayout>} />
                                
                                {/* Admin Route */}
                                <Route path="/administration" element={<Admin />} />
                                
                                {/* Payment callback pages (public, no layout) */}
                                <Route path="/payment/success" element={<PaymentSuccess />} />
                                <Route path="/payment/error" element={<PaymentError />} />
                            </Routes>
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                        {/* Noise overlay */}
                        <div className="noise-overlay"></div>
                    </div>
                </AuthProvider>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
